"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAreaTransfer_ClientComplete = void 0;
const isAreaTransfer_ClientComplete = (details) => {
    if (!details)
        return false;
    if (details === null)
        return false;
    // if details.address has a value then return true otherwise return false.
    if (details.address) {
        return true;
    }
    return false;
};
exports.isAreaTransfer_ClientComplete = isAreaTransfer_ClientComplete;
